import { render, staticRenderFns } from "./FiDetails.vue?vue&type=template&id=6db9f317&"
import script from "./FiDetails.vue?vue&type=script&lang=js&"
export * from "./FiDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports